import { render, staticRenderFns } from "./UserReels.vue?vue&type=template&id=6b6b2f73&scoped=true&"
import script from "./UserReels.vue?vue&type=script&lang=js&"
export * from "./UserReels.vue?vue&type=script&lang=js&"
import style0 from "./UserReels.vue?vue&type=style&index=0&id=6b6b2f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b2f73",
  null
  
)

export default component.exports